module.exports = __webpack_public_path__ + "img/nissan-used.c8662fd6.png";